import React, {useState, memo, useCallback, useMemo} from 'react';
import {Link, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import { useUserContext } from '../../context/User_Access';
import { useBaseUrlContext } from '../../context/Base_url'
import { useIncidentTrack } from '../../hooks/useSupport';

import {AppBar, Box, Toolbar, IconButton, Typography, Menu, Container, Avatar, Tooltip, MenuItem} from '@mui/material';

import {ThemeProvider } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import LogoutModal from '../modal/Modal_logout';

import { ThemeCustom } from "../../styles/Theme";
import NavStyle from './Nav_style.module.scss';

import logo from '../../assets/Docupath-Logo.svg';
import logoTestEnv from '../../assets/logo-test-env.svg'
import supportIcon from '../../assets/support.svg';
import changelogIcon from '../../assets/change_log.svg';
import HeadwayAppChangelog from "../HeadwayAppChangelog";


const NavArray = [
  {text:'Home', navigate:'/file_upload', fun:false, settingsItem:0, accessKey:true },
  {text:'Manage organizations',  navigate:'/settings/manage_organizations', fun:false, accessKey:'/organization'},
  {text:'Usage insights',  navigate:'/settings/usage_insights', fun:false, accessKey:'/reports'},
  {text:'Manage users',  navigate:'/settings/manage-users', fun:false, accessKey:'/users'},
  {text:'Destination format & APIs', navigate:'/settings/destination_format_and_apis', fun:false, accessKey:'/mappings' },
  {text:'Data export templates',  navigate:'/settings/data_export_templates', fun:false, accessKey:'/known_mappings'},
  {text:'Unknown mappings',  navigate:'/settings/unknown_mappings', fun:false, accessKey:'unknown_map'},
  {text:'Regions & countries',  navigate:'/settings/regions_and_countries', fun:false, accessKey:'/region'},
  {text:'Instruction builds',  navigate:'/settings/instruction_builds', fun:false, accessKey:'/instructions'},
  {text:'System settings',  navigate:'/settings/system_settings', fun:false, accessKey:'/organization'},
  {text:'User settings',  navigate:'/settings/user_settings', fun:false, accessKey:true},
  {text:'Activity logs',  navigate:'/settings/activity_logs', fun:false, accessKey:true},
  {text:'Sign out', fun:true, accessKey:true }
]

const NavArrayDevmode = [
  {text:'Home', navigate:'/file_upload', fun:false, settingsItem:0, accessKey:true },
  {text:'Manage organizations',  navigate:'/settings/manage_organizations?devMode=true', fun:false, accessKey:'/organization'},
  {text:'Usage insights',  navigate:'/settings/usage_insights?devMode=true', fun:false, accessKey:'/reports'},
  {text:'Manage users',  navigate:'/settings/manage-users?devMode=true', fun:false, accessKey:'/users'},
  {text:'Destination format & APIs', navigate:'/settings/destination_format_and_apis?devMode=true', fun:false, accessKey:'/mappings' },
  {text:'Data export templates',  navigate:'/settings/data_export_templates?devMode=true', fun:false, accessKey:'/known_mappings'},
  {text:'Unknown mappings',  navigate:'/settings/unknown_mappings?devMode=true', fun:false, accessKey:'unknown_map'},
  {text:'Regions & countries',  navigate:'/settings/regions_and_countries?devMode=true', fun:false, accessKey:'/region'},
  {text:'System settings',  navigate:'/settings/system_settings?devMode=true', fun:false, accessKey:'/organization'},
  {text:'Instruction builds',  navigate:'/settings/instruction_builds?devMode=true', fun:false, accessKey:'/instructions'},
  {text:'User settings',  navigate:'/settings/user_settings?devMode=true', fun:false, accessKey:true},
  {text:'Activity logs',  navigate:'/settings/activity_logs', fun:false, accessKey:true},
  {text:'Sign out', fun:true, accessKey:true }
]

const NavBar = (props) => {

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openLogout, setOpenLogout] = useState(false);
  const navigate = useNavigate();
  const {devMode, userName, userEmail, orgName, accessControl, orgLogoCustom} = useUserContext()
  const {env} = useBaseUrlContext()
  const [loading, setLoading] = useState(false);  // Loading state
  const { data: incidentData, isLoading: incidentLoading, isFetched: incidentSuccess,  isError:incidentError } = useIncidentTrack();

  const navItem = useMemo(() => {
    if (devMode) {
      return accessControl
        ? NavArrayDevmode.filter(tab =>
            tab.accessKey === true || 
            (Object.keys(accessControl).includes(tab.accessKey) && accessControl[tab.accessKey].write)
          )
        : [];
    } else {
      return accessControl
        ? NavArray.filter(tab =>
            tab.accessKey === true || 
            (Object.keys(accessControl).includes(tab.accessKey) && accessControl[tab.accessKey].write)
          )
        : [];
    }
  }, [devMode, accessControl]);


  const isMobile = useMediaQuery({
    query: '(max-width: 600px)'
  })

  const handleOpenUserMenu = useCallback((event) => {
    setAnchorElUser(event.currentTarget);
  }, []);

  const handleCloseUserMenu = useCallback(() => {
    setAnchorElUser(null);
  }, []);


  const fetchZendeskToken = async () => {
    const popup = window.open("/zendesk-loading", "_blank");
  
    if (!popup) {
      console.warn("Popup blocked by the browser!");
    }
  };
  

  const logout = useCallback(() =>{

    handleCloseUserMenu();
    setOpenLogout(true);

  }, [handleCloseUserMenu])

  const settings = useCallback((route, index) => {

    handleCloseUserMenu();   
    navigate(route); 
    props.setTabValue(index-1);
    
  }, [navigate, props.setTabValue, handleCloseUserMenu])
  
  return (
    <ThemeProvider theme={ThemeCustom}>
      <LogoutModal setOpenLogout={setOpenLogout} openLogout={openLogout} />
        <AppBar position="fixed" className={`bg-white shadow-none ${props.navBarBoader}`}>
        <Container maxWidth="false">
            <Toolbar disableGutters className='flex justify-between'>
                <div className='flex items-center'>
                  <Link to={devMode ? '/document_review?devMode=true':'/document_review'} className='flex items-center'>
                    <img src={env ? logoTestEnv:(orgLogoCustom ? orgLogoCustom : logo)} alt='Logo' className={`${NavStyle['nav-img-width']} object-contain w-[9rem] h-[1.875rem]`}/>
                  </Link>  
                </div>
                <Box sx={{ flexGrow: 0 }} className="flex items-center">
                <div className='mr-4 border-r border-0 border-solid border-borderGrayDark' >
                  <Tooltip title="30-day status" arrow>
                    <a href="https://status.docupath.app/" target="_blank" rel="noopener noreferrer">
                      <div className='cursor-pointer flex items-center'>
                        <div className={`${incidentData?.systemStatus === 'up' ? 'bg-secondary' : incidentData?.systemStatus === 'down' ? 'bg-warningYellow' : incidentError ? 'bg-borderGrayDark' : 'bg-secondary'} rounded-full w-3 h-3`}></div>
                        <Typography className='ml-2 mr-5 font-medium' variant="text18" component={'div'}>Uptime: {incidentData?.uptimePercentage ? incidentData?.uptimePercentage : incidentError ? 'N/A' : '100%'}</Typography>
                      </div>
                    </a>
                  </Tooltip>
                </div>   
                <Tooltip
                  title="Changelog"
                  arrow
                  componentsProps={{
                    tooltip: {
                      className: NavStyle['changelogs-tooltip']
                    },
                  }}
                >
                  <Link 
                    onClick={(e) => e.preventDefault()}
                    to="#"  // Prevents default navigation, handled in onClick
                    className={`changelogs-link ${NavStyle['changelogs-link']} text-primary hover:underline`} 
                  > 
                      <img src={changelogIcon} alt='SupportLink' className={`changelog-img ${NavStyle['changelog-img']} p-[0.25rem] hover:bg-platinum hover:bg-opacity-50 rounded-full object-contain w-[9rem] h-[2.700rem]`} />
                  </Link>
                </Tooltip>
                {/* Load the Headway widget */}
                <HeadwayAppChangelog />
                <Link 
                  to="#"  // Prevents default navigation, handled in onClick
                  className={`${NavStyle['support-link']} text-primary hover:underline`} 
                  onClick={async (e) => {
                    e.preventDefault(); // Prevent default link behavior
                    await fetchZendeskToken(); // Fetch token and handle redirection
                  }}  
                > 
                  <Tooltip title="Help center" arrow>
                    <img src={supportIcon} alt='SupportLink' className={`${NavStyle['support-img']} p-[0.25rem] hover:bg-platinum hover:bg-opacity-50 rounded-full object-contain w-[9rem] h-[2.700rem]`} />
                  </Tooltip>
                </Link>
                    <Box component={'div'} onClick={handleOpenUserMenu} className='flex items-center cursor-pointer tour-menu' >
                        <Typography className='mr-6 hidden sm:block pl-2' variant="text20" component={'div'}>{userName}</Typography>
                        <Tooltip title="Open settings" arrow>
                        <IconButton sx={{ p: 0, '&:hover':{backgroundColor:'transparent'} }} disableTouchRipple>
                            <Avatar alt={userName} src="/static/images/avatar/1.jpg" className='bg-primary ' />
                            <ArrowDropDownIcon />
                        </IconButton>
                        </Tooltip>
                    </Box>
                    <Menu
                      sx={{ mt: '45px', borderRadius:'1.25rem' }}
                      id="menu-navBar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                      }}
                      keepMounted
                      transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                      className='main-nav'
                    >   
                        <Typography component={'div'} variant="userDropdown" className={`${NavStyle['nav-item-wrapper']} ${NavStyle['nav-item-text-18']}`}>
                          {userName}
                        </Typography>
                        <Typography component={'div'} variant="userDropdown" className={`${NavStyle['nav-item-wrapper']} ${NavStyle['nav-text-sonicSilver']} ${NavStyle['nav-item-text']}`}>
                          {userEmail}
                        </Typography>
                        <Typography component={'div'} variant="userDropdown" className={`${NavStyle['nav-item-wrapper']} ${NavStyle['nav-item-text-gray']}`}>
                          {orgName}
                        </Typography>
                        {navItem.map((item, index) => (
                          <MenuItem  key={index} onClick={item.fun ? logout : ()=>{ settings(item.navigate, index)}} className={`${NavStyle['nav-item-wrapper']} main-nav-item`} >
                              <Typography component={'div'} variant="userDropdown" className={`${NavStyle['nav-item']} `}>
                                {item.text}
                              </Typography>
                          </MenuItem>
                        ))}
                    </Menu> 
                </Box>
            </Toolbar>
        </Container>
        </AppBar>
    </ThemeProvider>    
  );
}

export default memo(NavBar);